import * as React from 'react'
import { Field } from 'formik'
import { Select } from '@workwave-tidal/core/components'
import type { HideableOption } from '../formConfig'

type TechSelectProps = {
  techOptions: HideableOption[]
}

export function TechSelect(props: TechSelectProps) {
  const { techOptions } = props

  const sortedOptions = techOptions?.sort(
    (a: HideableOption, b: HideableOption) => {
      const labelA = a?.label?.toLowerCase()
      const labelb = b?.label?.toLowerCase()
      if (labelA < labelb) {
        return -1
      }
      if (labelA > labelb) {
        return 1
      }
      return 0
    },
  )

  return (
    <Field name="techId" size="medium" label="Tech">
      {({ field, form }) => (
        <Select<HideableOption>
          testId="filters-techSelect"
          key={'techId'}
          items={sortedOptions}
          getLabel={(option) => option.label}
          label="Tech"
          optionMode="normal"
          density="normal"
          getId={(o) => o?.id}
          value={techOptions?.find((row) => row?.id == field?.value) ?? null}
          onChange={(e) => {
            form?.setFieldValue('techId', e?.id)
          }}
          getOptionDisabled={(o) => o?.hidden ?? false}
          placeholder="Search Techs"
        />
      )}
    </Field>
  )
}
